// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file nodebase/v1/edge.proto (package nodebase.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { RequestMeta, ResponseMeta } from "./common_pb";
import { file_nodebase_v1_common } from "./common_pb";
import type { PublicWebIngressObservation, PublicWebRoute } from "./public_web_pb";
import { file_nodebase_v1_public_web } from "./public_web_pb";
import type { Endpoint } from "./worker_pb";
import { file_nodebase_v1_worker } from "./worker_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file nodebase/v1/edge.proto.
 */
export const file_nodebase_v1_edge: GenFile = /*@__PURE__*/
  fileDesc("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", [file_nodebase_v1_common, file_nodebase_v1_public_web, file_nodebase_v1_worker]);

/**
 * @generated from message nodebase.v1.EdgeNode
 */
export type EdgeNode = Message<"nodebase.v1.EdgeNode"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string region = 2;
   */
  region: string;

  /**
   * @generated from field: repeated nodebase.v1.Endpoint endpoints = 3;
   */
  endpoints: Endpoint[];

  /**
   * @generated from field: bytes wg_public_key = 4;
   */
  wgPublicKey: Uint8Array;

  /**
   * @generated from field: repeated nodebase.v1.EdgeRole roles = 5;
   */
  roles: EdgeRole[];

  /**
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: uint32 capacity = 7;
   */
  capacity: number;

  /**
   * @generated from field: string agent_version = 8;
   */
  agentVersion: string;

  /**
   * @generated from field: uint64 desired_config_version = 9;
   */
  desiredConfigVersion: bigint;

  /**
   * @generated from field: uint64 observed_config_version = 10;
   */
  observedConfigVersion: bigint;

  /**
   * @generated from field: int64 last_heartbeat_unix = 11;
   */
  lastHeartbeatUnix: bigint;

  /**
   * Last observed live load. Capacity is the configured ceiling; used is the
   * role-specific aggregate reported by the Edge agent.
   *
   * @generated from field: uint32 active_sessions = 12;
   */
  activeSessions: number;

  /**
   * @generated from field: uint32 capacity_used = 13;
   */
  capacityUsed: number;

  /**
   * @generated from field: uint64 exit_rx_bytes = 14;
   */
  exitRxBytes: bigint;

  /**
   * @generated from field: uint64 exit_tx_bytes = 15;
   */
  exitTxBytes: bigint;

  /**
   * @generated from field: repeated string supported_profile_ids = 16;
   */
  supportedProfileIds: string[];

  /**
   * Current Exit data-plane circuit state. This is independent from process
   * liveness so a Relay-capable Edge can remain online while Exit is withheld.
   *
   * ready | degraded | recovering
   *
   * @generated from field: string exit_data_plane_status = 17;
   */
  exitDataPlaneStatus: string;

  /**
   * Non-zero only after the running agent can enforce the complete per-Device
   * Managed Edge Exit lease snapshot carried by HeartbeatEdgeResponse.
   *
   * @generated from field: uint32 internet_exit_authority_version = 18;
   */
  internetExitAuthorityVersion: number;

  /**
   * Latest authenticated process/data-plane snapshot. It is intentionally a
   * point-in-time operational view rather than a per-user telemetry stream.
   * Cumulative counters reset when the Edge process restarts.
   *
   * @generated from field: nodebase.v1.EdgeRuntimeStats runtime_stats = 19;
   */
  runtimeStats?: EdgeRuntimeStats | undefined;
};

/**
 * Describes the message nodebase.v1.EdgeNode.
 * Use `create(EdgeNodeSchema)` to create a new message.
 */
export const EdgeNodeSchema: GenMessage<EdgeNode> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_edge, 0);

/**
 * EdgeRuntimeStats is the small capacity/pressure surface an operator needs to
 * distinguish ordinary traffic from an admission fuse or host exhaustion.
 * It contains no destinations, device ids, source addresses, or workspace ids.
 *
 * @generated from message nodebase.v1.EdgeRuntimeStats
 */
export type EdgeRuntimeStats = Message<"nodebase.v1.EdgeRuntimeStats"> & {
  /**
   * @generated from field: uint32 exit_active_sessions = 1;
   */
  exitActiveSessions: number;

  /**
   * @generated from field: uint32 exit_capacity = 2;
   */
  exitCapacity: number;

  /**
   * @generated from field: uint32 pending_handshakes = 3;
   */
  pendingHandshakes: number;

  /**
   * @generated from field: uint32 pending_capacity = 4;
   */
  pendingCapacity: number;

  /**
   * @generated from field: uint64 accepted_total = 5;
   */
  acceptedTotal: bigint;

  /**
   * @generated from field: uint64 authenticated_total = 6;
   */
  authenticatedTotal: bigint;

  /**
   * @generated from field: uint64 pending_rejected_total = 7;
   */
  pendingRejectedTotal: bigint;

  /**
   * @generated from field: uint64 source_rejected_total = 8;
   */
  sourceRejectedTotal: bigint;

  /**
   * @generated from field: uint64 handshake_rejected_total = 9;
   */
  handshakeRejectedTotal: bigint;

  /**
   * @generated from field: uint64 capacity_rejected_total = 10;
   */
  capacityRejectedTotal: bigint;

  /**
   * @generated from field: uint64 exit_capacity_rejected_total = 11;
   */
  exitCapacityRejectedTotal: bigint;

  /**
   * @generated from field: uint64 exit_workspace_rejected_total = 12;
   */
  exitWorkspaceRejectedTotal: bigint;

  /**
   * @generated from field: uint64 exit_rate_rejected_total = 13;
   */
  exitRateRejectedTotal: bigint;

  /**
   * @generated from field: uint64 exit_quota_rejected_total = 14;
   */
  exitQuotaRejectedTotal: bigint;

  /**
   * @generated from field: uint64 handshake_latency_ms_total = 15;
   */
  handshakeLatencyMsTotal: bigint;

  /**
   * @generated from field: uint64 handshake_latency_samples = 16;
   */
  handshakeLatencySamples: bigint;

  /**
   * @generated from field: uint64 memory_used_bytes = 17;
   */
  memoryUsedBytes: bigint;

  /**
   * @generated from field: uint64 memory_limit_bytes = 18;
   */
  memoryLimitBytes: bigint;

  /**
   * @generated from field: uint64 fd_used = 19;
   */
  fdUsed: bigint;

  /**
   * @generated from field: uint64 fd_limit = 20;
   */
  fdLimit: bigint;

  /**
   * @generated from field: uint64 conntrack_used = 21;
   */
  conntrackUsed: bigint;

  /**
   * @generated from field: uint64 conntrack_limit = 22;
   */
  conntrackLimit: bigint;

  /**
   * @generated from field: int64 reported_unix = 23;
   */
  reportedUnix: bigint;
};

/**
 * Describes the message nodebase.v1.EdgeRuntimeStats.
 * Use `create(EdgeRuntimeStatsSchema)` to create a new message.
 */
export const EdgeRuntimeStatsSchema: GenMessage<EdgeRuntimeStats> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_edge, 1);

/**
 * EdgeAssignment is an operator-approved canary binding. It belongs to the
 * Workspace, not to one Worker instance, so Worker rebuilds do not lose it.
 *
 * @generated from message nodebase.v1.EdgeAssignment
 */
export type EdgeAssignment = Message<"nodebase.v1.EdgeAssignment"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: nodebase.v1.EdgeRole role = 2;
   */
  role: EdgeRole;

  /**
   * @generated from field: string region = 3;
   */
  region: string;

  /**
   * @generated from field: string edge_node_id = 4;
   */
  edgeNodeId: string;

  /**
   * @generated from field: uint64 config_version = 5;
   */
  configVersion: bigint;
};

/**
 * Describes the message nodebase.v1.EdgeAssignment.
 * Use `create(EdgeAssignmentSchema)` to create a new message.
 */
export const EdgeAssignmentSchema: GenMessage<EdgeAssignment> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_edge, 2);

/**
 * @generated from message nodebase.v1.RegisterEdgeRequest
 */
export type RegisterEdgeRequest = Message<"nodebase.v1.RegisterEdgeRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string bootstrap_token = 2;
   */
  bootstrapToken: string;

  /**
   * @generated from field: bytes api_public_key = 3;
   */
  apiPublicKey: Uint8Array;

  /**
   * @generated from field: bytes wg_public_key = 4;
   */
  wgPublicKey: Uint8Array;

  /**
   * @generated from field: string agent_version = 5;
   */
  agentVersion: string;
};

/**
 * Describes the message nodebase.v1.RegisterEdgeRequest.
 * Use `create(RegisterEdgeRequestSchema)` to create a new message.
 */
export const RegisterEdgeRequestSchema: GenMessage<RegisterEdgeRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_edge, 3);

/**
 * @generated from message nodebase.v1.RegisterEdgeResponse
 */
export type RegisterEdgeResponse = Message<"nodebase.v1.RegisterEdgeResponse"> & {
  /**
   * @generated from field: string edge_node_id = 1;
   */
  edgeNodeId: string;

  /**
   * @generated from field: uint64 desired_config_version = 2;
   */
  desiredConfigVersion: bigint;

  /**
   * @generated from field: nodebase.v1.ResponseMeta meta = 3;
   */
  meta?: ResponseMeta | undefined;
};

/**
 * Describes the message nodebase.v1.RegisterEdgeResponse.
 * Use `create(RegisterEdgeResponseSchema)` to create a new message.
 */
export const RegisterEdgeResponseSchema: GenMessage<RegisterEdgeResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_edge, 4);

/**
 * @generated from message nodebase.v1.EdgeObservedState
 */
export type EdgeObservedState = Message<"nodebase.v1.EdgeObservedState"> & {
  /**
   * @generated from field: uint64 config_version = 1;
   */
  configVersion: bigint;

  /**
   * @generated from field: uint32 active_sessions = 2;
   */
  activeSessions: number;

  /**
   * @generated from field: uint32 capacity_used = 3;
   */
  capacityUsed: number;

  /**
   * @generated from field: uint64 exit_rx_bytes = 4;
   */
  exitRxBytes: bigint;

  /**
   * @generated from field: uint64 exit_tx_bytes = 5;
   */
  exitTxBytes: bigint;

  /**
   * Concrete outer-carrier profiles this running Edge can actually accept.
   * Empty is the legacy stls-go-v1 capability so old agents remain valid.
   *
   * @generated from field: repeated string supported_profile_ids = 6;
   */
  supportedProfileIds: string[];

  /**
   * Derived from a bounded in-memory window of attributable Exit session
   * outcomes. Empty is a legacy agent and remains fail-open during rollout.
   *
   * ready | degraded | recovering
   *
   * @generated from field: string exit_data_plane_status = 7;
   */
  exitDataPlaneStatus: string;

  /**
   * Closed and current UTC-hour windows. A successful heartbeat durably
   * records every supplied cumulative window; the Edge may then discard
   * closed windows. Destinations are deliberately absent.
   *
   * @generated from field: repeated nodebase.v1.EdgeExitUsageWindow exit_usage_windows = 8;
   */
  exitUsageWindows: EdgeExitUsageWindow[];

  /**
   * Durable offline-credit position for each assigned Workspace. reserved is
   * conservative: after a crash an unused tail remains spent rather than
   * allowing the same Control-issued credit to be consumed twice.
   *
   * @generated from field: repeated nodebase.v1.EdgeExitCreditState exit_credit_states = 9;
   */
  exitCreditStates: EdgeExitCreditState[];

  /**
   * Non-zero declares that this agent enforces Control-issued byte ceilings
   * on both TCP and UDP before forwarding. Control keeps Exit disabled for
   * legacy agents while leaving Relay available.
   *
   * @generated from field: uint32 exit_accounting_version = 10;
   */
  exitAccountingVersion: number;

  /**
   * Version 1 means the Edge atomically replaces its complete per-Device
   * Managed Edge Exit authority on every authoritative heartbeat response.
   *
   * @generated from field: uint32 internet_exit_authority_version = 11;
   */
  internetExitAuthorityVersion: number;

  /**
   * @generated from field: nodebase.v1.EdgeRuntimeStats runtime_stats = 12;
   */
  runtimeStats?: EdgeRuntimeStats | undefined;

  /**
   * Understands probe-only aliases and absolute domain lease expiry.
   *
   * @generated from field: bool public_web_domains = 13;
   */
  publicWebDomains: boolean;

  /**
   * @generated from field: repeated nodebase.v1.PublicWebIngressObservation public_web_observations = 14;
   */
  publicWebObservations: PublicWebIngressObservation[];
};

/**
 * Describes the message nodebase.v1.EdgeObservedState.
 * Use `create(EdgeObservedStateSchema)` to create a new message.
 */
export const EdgeObservedStateSchema: GenMessage<EdgeObservedState> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_edge, 5);

/**
 * EdgeExitUsageWindow is cumulative for one Edge/Workspace/purpose/hour.
 * up is device-or-Worker to Internet; down is the reverse. Control upserts the
 * maximum observed counters, making heartbeat retries idempotent.
 *
 * @generated from message nodebase.v1.EdgeExitUsageWindow
 */
export type EdgeExitUsageWindow = Message<"nodebase.v1.EdgeExitUsageWindow"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * edge_exit; older values exist only during bounded cutover
   *
   * @generated from field: string purpose = 2;
   */
  purpose: string;

  /**
   * @generated from field: int64 window_start_unix = 3;
   */
  windowStartUnix: bigint;

  /**
   * @generated from field: uint64 up_bytes = 4;
   */
  upBytes: bigint;

  /**
   * @generated from field: uint64 down_bytes = 5;
   */
  downBytes: bigint;

  /**
   * @generated from field: uint64 connections = 6;
   */
  connections: bigint;
};

/**
 * Describes the message nodebase.v1.EdgeExitUsageWindow.
 * Use `create(EdgeExitUsageWindowSchema)` to create a new message.
 */
export const EdgeExitUsageWindowSchema: GenMessage<EdgeExitUsageWindow> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_edge, 6);

/**
 * @generated from message nodebase.v1.EdgeExitCreditState
 */
export type EdgeExitCreditState = Message<"nodebase.v1.EdgeExitCreditState"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: int64 month_start_unix = 2;
   */
  monthStartUnix: bigint;

  /**
   * @generated from field: uint64 reserved_bytes = 3;
   */
  reservedBytes: bigint;
};

/**
 * Describes the message nodebase.v1.EdgeExitCreditState.
 * Use `create(EdgeExitCreditStateSchema)` to create a new message.
 */
export const EdgeExitCreditStateSchema: GenMessage<EdgeExitCreditState> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_edge, 7);

/**
 * EdgeExitCredit is the cumulative byte ceiling this one Edge may spend for a
 * Workspace during one UTC calendar month. Control serializes grants across
 * all Edges, so their sum never exceeds quota_bytes. A grant is not reclaimed
 * during its month; assignment changes therefore fail safe at the cost of a
 * bounded stranded tail.
 *
 * @generated from message nodebase.v1.EdgeExitCredit
 */
export type EdgeExitCredit = Message<"nodebase.v1.EdgeExitCredit"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: int64 month_start_unix = 2;
   */
  monthStartUnix: bigint;

  /**
   * @generated from field: uint64 granted_bytes = 3;
   */
  grantedBytes: bigint;

  /**
   * @generated from field: uint64 quota_bytes = 4;
   */
  quotaBytes: bigint;
};

/**
 * Describes the message nodebase.v1.EdgeExitCredit.
 * Use `create(EdgeExitCreditSchema)` to create a new message.
 */
export const EdgeExitCreditSchema: GenMessage<EdgeExitCredit> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_edge, 8);

/**
 * EdgeExitDeviceLease is Control's live-session fence for one Device selected
 * onto this exact Edge. Tickets admit new streams; this snapshot owns whether
 * an admitted stream may continue after preference, entitlement or Device
 * state changes.
 *
 * @generated from message nodebase.v1.EdgeExitDeviceLease
 */
export type EdgeExitDeviceLease = Message<"nodebase.v1.EdgeExitDeviceLease"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string device_id = 2;
   */
  deviceId: string;

  /**
   * @generated from field: string region = 3;
   */
  region: string;

  /**
   * @generated from field: uint64 generation = 4;
   */
  generation: bigint;

  /**
   * A retiring lease preserves only streams admitted before cutover. New
   * streams must match the non-existing-only lease for this Device.
   *
   * @generated from field: bool existing_only = 5;
   */
  existingOnly: boolean;

  /**
   * @generated from field: int64 expires_unix = 6;
   */
  expiresUnix: bigint;
};

/**
 * Describes the message nodebase.v1.EdgeExitDeviceLease.
 * Use `create(EdgeExitDeviceLeaseSchema)` to create a new message.
 */
export const EdgeExitDeviceLeaseSchema: GenMessage<EdgeExitDeviceLease> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_edge, 9);

/**
 * @generated from message nodebase.v1.HeartbeatEdgeRequest
 */
export type HeartbeatEdgeRequest = Message<"nodebase.v1.HeartbeatEdgeRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string agent_version = 2;
   */
  agentVersion: string;

  /**
   * @generated from field: nodebase.v1.EdgeObservedState observed = 3;
   */
  observed?: EdgeObservedState | undefined;
};

/**
 * Describes the message nodebase.v1.HeartbeatEdgeRequest.
 * Use `create(HeartbeatEdgeRequestSchema)` to create a new message.
 */
export const HeartbeatEdgeRequestSchema: GenMessage<HeartbeatEdgeRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_edge, 10);

/**
 * @generated from message nodebase.v1.HeartbeatEdgeResponse
 */
export type HeartbeatEdgeResponse = Message<"nodebase.v1.HeartbeatEdgeResponse"> & {
  /**
   * @generated from field: nodebase.v1.ResponseMeta meta = 1;
   */
  meta?: ResponseMeta | undefined;

  /**
   * @generated from field: uint64 desired_config_version = 2;
   */
  desiredConfigVersion: bigint;

  /**
   * @generated from field: repeated nodebase.v1.EdgeAssignment assignments = 3;
   */
  assignments: EdgeAssignment[];

  /**
   * The Edge verifies short-lived Relay tickets offline. Empty means Relay
   * issuance is disabled and the node must not accept production sessions.
   *
   * @generated from field: bytes relay_ticket_public_key = 4;
   */
  relayTicketPublicKey: Uint8Array;

  /**
   * False means stop accepting new Relay sessions. Existing paired streams
   * may drain; registration/config convergence and operator draining both use
   * this gate.
   *
   * @generated from field: bool relay_enabled = 5;
   */
  relayEnabled: boolean;

  /**
   * Authenticates the ShadowTLS carrier. Sensitive; never log or persist.
   *
   * @generated from field: string relay_carrier_password = 6;
   */
  relayCarrierPassword: string;

  /**
   * Maximum accepted carrier connections. One waiting home or one Client
   * stream consumes one unit; zero while this Edge has no Relay role.
   *
   * @generated from field: uint32 relay_capacity = 7;
   */
  relayCapacity: number;

  /**
   * Exit shares the authenticated carrier listener and ticket key with Relay,
   * but has independent role/assignment gating.
   *
   * @generated from field: bool exit_enabled = 8;
   */
  exitEnabled: boolean;

  /**
   * Operator-published endpoint hosts for every Edge in the fleet. An
   * Exit-enabled agent resolves these locally and rejects their addresses as
   * destinations, preventing self loops and Edge-to-Edge chains.
   *
   * @generated from field: repeated string exit_blocked_hosts = 9;
   */
  exitBlockedHosts: string[];

  /**
   * @generated from field: repeated nodebase.v1.EdgeExitCredit exit_credits = 10;
   */
  exitCredits: EdgeExitCredit[];

  /**
   * @generated from field: repeated nodebase.v1.EdgeExitDeviceLease exit_device_leases = 11;
   */
  exitDeviceLeases: EdgeExitDeviceLease[];

  /**
   * False means no lease statement was made and an older agent must retain its
   * previous state. Version-1 Control always sends true to version-1 Edges,
   * including for an empty snapshot, so removal is an explicit revocation.
   *
   * @generated from field: bool exit_device_leases_authoritative = 12;
   */
  exitDeviceLeasesAuthoritative: boolean;

  /**
   * Complete route snapshot for an EDGE_ROLE_INGRESS node. Older agents ignore
   * it; false means no statement was made and must not revoke cached routes.
   *
   * @generated from field: repeated nodebase.v1.PublicWebRoute public_web_routes = 13;
   */
  publicWebRoutes: PublicWebRoute[];

  /**
   * @generated from field: bool public_web_routes_authoritative = 14;
   */
  publicWebRoutesAuthoritative: boolean;

  /**
   * @generated from field: bool public_web_enabled = 15;
   */
  publicWebEnabled: boolean;
};

/**
 * Describes the message nodebase.v1.HeartbeatEdgeResponse.
 * Use `create(HeartbeatEdgeResponseSchema)` to create a new message.
 */
export const HeartbeatEdgeResponseSchema: GenMessage<HeartbeatEdgeResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_edge, 11);

/**
 * EdgeRole is the set of roles one edge-node software build can enable.
 *
 * @generated from enum nodebase.v1.EdgeRole
 */
export enum EdgeRole {
  /**
   * @generated from enum value: EDGE_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * default rendezvous, keep-connected, obfuscation carrier
   *
   * @generated from enum value: EDGE_ROLE_RELAY = 1;
   */
  RELAY = 1,

  /**
   * paid acceleration + multi-hop
   *
   * @generated from enum value: EDGE_ROLE_TRANSIT = 2;
   */
  TRANSIT = 2,

  /**
   * shared / dedicated egress
   *
   * @generated from enum value: EDGE_ROLE_EXIT = 3;
   */
  EXIT = 3,

  /**
   * Public Web ingress
   *
   * @generated from enum value: EDGE_ROLE_INGRESS = 4;
   */
  INGRESS = 4,
}

/**
 * Describes the enum nodebase.v1.EdgeRole.
 */
export const EdgeRoleSchema: GenEnum<EdgeRole> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_edge, 0);

/**
 * EdgeService is the platform-node control loop. Registration burns an
 * operator-created one-time bootstrap token; every later call authenticates
 * the Edge's Ed25519 node identity just like a Worker.
 *
 * @generated from service nodebase.v1.EdgeService
 */
export const EdgeService: GenService<{
  /**
   * @generated from rpc nodebase.v1.EdgeService.RegisterEdge
   */
  registerEdge: {
    methodKind: "unary";
    input: typeof RegisterEdgeRequestSchema;
    output: typeof RegisterEdgeResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.EdgeService.HeartbeatEdge
   */
  heartbeatEdge: {
    methodKind: "unary";
    input: typeof HeartbeatEdgeRequestSchema;
    output: typeof HeartbeatEdgeResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_nodebase_v1_edge, 0);

